import { cx } from "@suse-o11y/class-variance";
import { Collapsible } from "@suse-o11y/collapsible";
import React from "react";

import { Wrap } from "../conditional-wrapper/Wrap";

import styles from "./widget.module.css";
import { useIsWidgetExpandable } from "./widget-context";

export interface WidgetBodyProps {
	/**
	 * Whether to render the body as a card.
	 *
	 * @default false
	 */
	card?: boolean;

	className?: string;

	children: React.ReactNode;
}

export const WidgetBody = React.forwardRef<HTMLDivElement, WidgetBodyProps & React.HTMLAttributes<HTMLDivElement>>(
	({ card = false, className, ...props }, ref) => {
		const expandable = useIsWidgetExpandable();

		return (
			<Wrap
				if={expandable}
				with={
					<Collapsible className="fade-in-0 fade-out-0 max-h-in-from-0 max-h-in-to-content-height max-h-out-from-content-height max-h-out-to-0 overflow-hidden duration-200 motion-safe:collapsible-state-closed:animate-out motion-safe:collapsible-state-open:animate-in" />
				}
			>
				<div className={cx(className, styles.body, card && styles.bodyCard)} ref={ref} {...props} />
			</Wrap>
		);
	},
);
